import { useTranslation } from "react-i18next"

const useDisplayDate = (dtDeb, dtEnd, running) => {
  const { t } = useTranslation()

  const formater = new Intl.DateTimeFormat("fr", {
    month: "long",
    year: "numeric",
  })
  const strDeb = formater.format(new Date(dtDeb))
  const strFin = dtEnd
    ? `${t("date.jusqua")} ${formater.format(new Date(dtEnd))}`
    : ""
  const strRunning = running ? t("date.running") : ""

  return `${t("date.depuisle")} ${strDeb} ${strRunning}${strFin}`
}

export default useDisplayDate
